import { ResendCodeButton } from './resend_code_button'
import { SendCodeButton } from './send_code_button'

export const CodeButtons = ({ phoneNumber, ownerId, phoneNumberValid }) => (
  <>
    <SendCodeButton phoneNumber={phoneNumber} disabled={!phoneNumberValid} ownerId={ownerId} />
    <ResendCodeButton phoneNumber={phoneNumber} ownerId={ownerId} />
  </>
)
